import {BaseSupplier} from '@dms/api/warehouse';

export const suppliersMock: BaseSupplier[] = [
  {
    id: 'a024ebfe-b790-47b2-ac85-da86ac458869',
    name: 'Hyundai Motor Czech s.r.o.',
  },
  {
    id: 'c5dd0275-2599-42fb-bf9d-f657a30e1e32',
    name: 'Mercedes-Benz Česká republika s.r.o.',
  },
  {
    id: '0515d5a4-6b12-4333-8f6e-8256061d116b',
    name: 'Lesy České republiky, s.p.',
  },
  {
    id: 'dba858f2-2b10-4efa-a4df-30f8f48ffccf',
    name: 'ADRIA GOLD, s.r.o.',
  },
  {
    id: '9439899f-5df6-4a40-8e64-62181760fc4c',
    name: 'MADETA a. s.',
  },
  {
    id: 'ed9f6bc5-746b-4d6b-90fd-a7ed5a06ecb8',
    name: 'E-AGEO.cz s.r.o.',
  },
  {
    id: 'dc388756-74f1-44aa-8489-2c726935cf82',
    name: 'ŠkoFIN s.r.o.',
  },
  {
    id: 'baad633e-2c94-44af-a3f8-46c8541fce16',
    name: 'NUEVO',
  },
  {
    id: 'b5e87e96-dffc-40e0-be8d-583c82c9c998',
    name: 'Paweł Tkocz',
  },
  {
    id: '38394f75-1eb5-4f9d-822c-fa4d8d6921be',
    name: 'Hyundai Motor Czech s. r. o., organizačná zložka Slovakia',
  },
  {
    id: '7c334ff6-1695-42f4-8e3a-6a6be897b28d',
    name: 'Mechanic',
  },
  {
    id: 'b3183e22-bb0b-4321-9cf9-ed20ad0300e8',
    name: 'HOIT s.r.o.',
  },
  {
    id: '77d8c97c-48dd-4a8d-a2cf-a21fcce40f04',
    name: 'Martek Technologies s.r.o.',
  },
  {
    id: '755a2749-071e-4c9c-8404-b269a4968477',
    name: 'Albert Česká republika, s.r.o.',
  },
  {
    id: 'f8918495-30e5-4d55-80ed-61a676a48681',
    name: 'LKQ CZ s.r.o.',
  },
  {
    id: '3194a87e-8d88-4d87-9c4b-cdbac044ee38',
    name: '1. Virtuální s.r.o.',
  },
];
